import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询列表
export const queryMagazines: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMagazines', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/design/group/list', payload);
    const res: IPageData = await $http.post('/v1/design/dpg/pagelist', payload);
    commit('setMagazines', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setMagazines', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询杂志详情
export const queryMagazineDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMagazineDetail', { data: null, loading: true });
    // const res = await $http.get(`/design/group/get/${payload}`);
    const res = await $http.get(`/v1/design/dpg/${payload}/detail`);
    commit('setMagazineDetail', { data: res });
  } catch (e) {
    commit('setMagazineDetail', { data: null });
  }
};

// 编辑杂志
export const editMagazine: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/design/magazine/modify', payload);
    await $http.post('/v1/design/mag/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除杂志
export const deleteMagazine: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, visible: true, loading: true });
    // await $http.post('/design/magazine/delete', payload);
    await $http.post('/v1/design/mag/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量上下架
export const shelfMagazine: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  commit('setConfirm', { ...state.confirm, loading: true });

  if (payload.operate === false) {
    // 下架
    try {
      // await $http.post('/design/group/batch/shelf', payload);
      await $http.post('/v1/design/dpg/shelf', payload);
    } finally {
      commit('setConfirm', { visible: false });
    }
  } else if (payload.operate === true && payload.release !== true) {
    // 发布
    try {
      // 发送请求的时候忽略了 1626 业务错误，所以不会进 catch 分支
      // const res: any = await $http.post('/design/group/batch/shelf', payload, { ignoreCode: [1626] });
      const res: any = await $http.post('/v1/design/dpg/shelf', payload, { ignoreCode: [1626] });
      // 如果出现了 1626 业务错误，说明发布的杂志里存在未发布的物料，此时打开再次确认发布弹窗
      const visible = res?.rtnCode === 1626;
      const data = JSON.parse((res?.data || [])[0] || '[]')[0];
      commit('setShelfCheck', { visible, data, params: payload });
      store.commit('common/setToast', { visible: !visible, text: '发布成功' });
    } finally {
      commit('setConfirm', { visible: false });
    }
  } else if (payload.operate === true && payload.release === true) {
    // 再次确认发布（强制发布）
    try {
      commit('setShelfCheck', { ...state.shelfCheck, loading: true });
      // await $http.post('/design/group/batch/shelf', payload);
      await $http.post('/v1/design/dpg/shelf', payload);
      store.commit('common/setToast', { visible: true, text: '发布成功' });
    } finally {
      commit('setShelfCheck', { visible: false });
    }
  }
};

// 查询已经授权的企业
export const queryMagazineAuths: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMagazineAuths', { ...state.auths, loading: true });
    // const res: IPageData = await $http.post('/authorization/magazine/detail', payload);
    const {
      list, pageNum, pageSize, total,
    } = await $http.post('/v1/data/system/org/listbyauthedmag', payload);
    commit('setMagazineAuths', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setMagazineAuths', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询未授权的企业
export const queryMagazineUnAuths: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMagazineUnAuths', { ...state.unAuths, loading: true });
    // const res: IPageData = await $http.post('/authorization/org/list', payload);
    const res: IPageData = await $http.post('/v1/data/baseinfo/brand/authpagelist', payload);
    commit('setMagazineUnAuths', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setMagazineUnAuths', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 添加授权
export const createMagazineAuth: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/authorization/ref/create', payload);
    await $http.post('/v1/design/mag/auth', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 取消授权
export const deleteMagazineAuth: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/authorization/ref/delete', payload);
    await $http.post('/v1/baseinfo/brand/deleteauthorg', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
